module.exports = __webpack_public_path__ + "assets/img/dc.14a23167.png";